/** Where the BottomCTA takes the data it displays from. */
export enum BottomCTASource {
  /** No dates searched: the "from" price on the hotel details. */
  Dateless = 'Dateless',
  /** Filtered rooms: the offer or bundle the customer picked on Search. */
  Rooms = 'Rooms',
  /** Top-offers, with split booking promoted into the primary position. */
  SplitBooking = 'SplitBooking',
  /** Top-offers primary offer. */
  TopOffer = 'TopOffer',
  Loading = 'Loading',
  /** Nothing left to show once offers came back empty. */
  Empty = 'Empty'
}

interface Params {
  hasDatelessPrice: boolean
  /**
   * The rooms-backed bar only exists on mobile. On desktop the bar keeps
   * taking top-offers, so the rooms rules below have to stay out of the way.
   */
  isRoomsSourceEnabled: boolean
  hasSelectedOfferOrBundle: boolean
  shouldRenderPrimaryRoomOffer: boolean
  isComplete: boolean
  showSplitBookingLoader: boolean
  hasPrimaryOffer: boolean
  hasPrimarySplitBookingOffer: boolean
}

export const getBottomCTASource = ({
  hasDatelessPrice,
  isRoomsSourceEnabled,
  hasSelectedOfferOrBundle,
  shouldRenderPrimaryRoomOffer,
  isComplete,
  showSplitBookingLoader,
  hasPrimaryOffer,
  hasPrimarySplitBookingOffer
}: Params): BottomCTASource => {
  if (hasDatelessPrice) return BottomCTASource.Dateless

  if (isRoomsSourceEnabled) {
    if (shouldRenderPrimaryRoomOffer) return BottomCTASource.Rooms
    // A selection pins the bar to the rooms data, so once that came back
    // without rooms nor a split booking there is nothing to show - the
    // top-offers price isn't the one the customer picked.
    if (hasSelectedOfferOrBundle) return BottomCTASource.Empty
  }

  if (isComplete && !hasPrimaryOffer && !hasPrimarySplitBookingOffer)
    return BottomCTASource.Empty
  if (!isComplete || showSplitBookingLoader) return BottomCTASource.Loading
  if (hasPrimarySplitBookingOffer) return BottomCTASource.SplitBooking

  return BottomCTASource.TopOffer
}
